import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { authAPI, apiHelpers } from '../api/api';
import '../css/Login.css';

const Register = ({ onSwitchToLogin }) => {
  const [name, setName] = useState('');
  const [taxNumber, setTaxNumber] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({ score: 0, label: '', checks: {} });

  const validateTaxNumber = (taxNum) => {
    const cleanedTax = taxNum.replace(/[-\s]/g, '');
    // 8 számjegy (rövid) vagy 11 számjegy (teljes) adószám
    return /^\d{8}$/.test(cleanedTax) || /^\d{11}$/.test(cleanedTax);
  };

  const checkPasswordStrength = (pwd) => {
    const checks = {
      minLength: pwd.length >= 8,
      hasLowercase: /[a-z]/.test(pwd),
      hasUppercase: /[A-Z]/.test(pwd),
      hasNumber: /[0-9]/.test(pwd),
      hasSpecial: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd)
    };

    const score = Object.values(checks).filter(Boolean).length;

    let label = '';
    if (score === 0) label = '';
    else if (score <= 2) label = 'Gyenge';
    else if (score <= 3) label = 'Közepes';
    else if (score <= 4) label = 'Jó';
    else label = 'Erős';

    setPasswordStrength({ score, label, checks });
    return score === 5;
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    checkPasswordStrength(newPassword);
  };

  const isPasswordStrong = () => {
    return passwordStrength.score === 5;
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error('Kérjük, adja meg a nevét!');
      return;
    }

    if (!validateTaxNumber(taxNumber)) {
      toast.error('Érvénytelen adószám formátum! (pl: 12345678-1-23)');
      return;
    }

    if (!isPasswordStrong()) {
      toast.error('A jelszónak erősnek kell lennie! (min. 8 karakter, kis- és nagybetű, szám, speciális karakter)');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('A jelszavak nem egyeznek!');
      return;
    }

    setIsLoading(true);

    try {
      await authAPI.register({
        name,
        taxNumber: taxNumber.replace(/[-\s]/g, ''),
        email,
        password
      });

      toast.success('Sikeres regisztráció! Most már bejelentkezhet.');
      setTimeout(() => {
        if (onSwitchToLogin) {
          onSwitchToLogin();
        }
      }, 1500);
    } catch (error) {
      toast.error(apiHelpers.handleApiError(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form className="login-form register-form" onSubmit={handleRegister}>
      <h2>Regisztráció</h2>

      <label htmlFor="name">Név <span className="required-star">*</span></label>
      <input
        type="text"
        id="name"
        placeholder="Teljes név..."
        value={name}
        onChange={e => setName(e.target.value)}
        required
        disabled={isLoading}
      />

      <label htmlFor="taxNumber">Adószám <span className="required-star">*</span></label>
      <input
        type="text"
        id="taxNumber"
        placeholder="12345678-1-23"
        value={taxNumber}
        onChange={e => setTaxNumber(e.target.value)}
        required
        disabled={isLoading}
      />

      <label htmlFor="email">Email cím <span className="required-star">*</span></label>
      <input
        type="email"
        id="email"
        placeholder="Email cím..."
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        disabled={isLoading}
      />

      <label htmlFor="password">Jelszó <span className="required-star">*</span></label>
      <input
        type="password"
        id="password"
        placeholder="Jelszó..."
        value={password}
        onChange={handlePasswordChange}
        required
        disabled={isLoading}
        minLength={8}
      />
      {password && (
        <div className="password-strength">
          <div className="password-strength-header">
            <div className="password-strength-bar">
              <div
                className={`password-strength-fill strength-${passwordStrength.score}`}
                style={{ width: `${(passwordStrength.score / 5) * 100}%` }}
              />
            </div>
            <span className={`password-strength-label strength-${passwordStrength.score}`}>
              {passwordStrength.label}
            </span>
          </div>
          <div className="password-requirements">
            <span className={passwordStrength.checks.minLength ? 'met' : ''}>Min. 8 karakter</span>
            <span className={passwordStrength.checks.hasLowercase ? 'met' : ''}>Kisbetű</span>
            <span className={passwordStrength.checks.hasUppercase ? 'met' : ''}>Nagybetű</span>
            <span className={passwordStrength.checks.hasNumber ? 'met' : ''}>Szám</span>
            <span className={passwordStrength.checks.hasSpecial ? 'met' : ''}>Speciális</span>
          </div>
        </div>
      )}

      <label htmlFor="confirmPassword">Jelszó megerősítése <span className="required-star">*</span></label>
      <input
        type="password"
        id="confirmPassword"
        placeholder="Jelszó újra..."
        value={confirmPassword}
        onChange={e => setConfirmPassword(e.target.value)}
        required
        disabled={isLoading}
        minLength={6}
      />

      <button type="submit" disabled={isLoading}>
        {isLoading ? 'Regisztráció...' : 'Regisztráció'}
      </button>

      <div className="login-register-link">
        Már van fiókja?
        <span onClick={onSwitchToLogin}>Bejelentkezés</span>
      </div>
    </form>
  );
};

export default Register;
